import React from "react";
import swal from 'sweetalert';

import ModulePanel from "../../../ModulePanel";
import Server from "../../../../services/Server";

const NewStreamTarget = ({ id, videoServer, setTargets, firebase, setCurrentView, transcoderId, update = false, record = {}, custom_type = '' })=>{

    const [isLoading, setLoadingStatus] = React.useState(false);
    const [resName, setResName] = React.useState('');
    const theForm = React.useRef(null);

    const changeName = (newName)=>{
        setResName(newName.replace(/ /gi, '_'));
    }

    React.useEffect(()=>{
        let url_server = '';
        let provider = 'rtmp';
        
        if (custom_type === 'facebook'){
            url_server = 'rtmps://live-api-s.facebook.com:443/rtmp/';
            provider = 'rtmps';
        }

        if (custom_type === 'youtube') {
            url_server = 'rtmp://a.rtmp.youtube.com/live2';
        }

        if (custom_type === 'twitch') {
            url_server = 'rtmp://live.twitch.tv/app';
        }
        
        if (theForm.current) {
            theForm.current.elements['server'].value = url_server;
            theForm.current.elements['provider'].value = provider;
        }
    }, [custom_type]);

    React.useEffect(()=>{
        if (update){
            for (var index in record){
                if (theForm.current.elements[index] !== undefined){
                    theForm.current.elements[index].value = record[index];
                }
            }
            setResName(record.name);
        }
    }, [record, update]);

    const onSubmit = (e)=>{
        e.preventDefault();
        setLoadingStatus(true);
        const 
            limit = (e.target.elements.length - 1),
            data = { eventId : id};

        for (var index = 0; index < limit; index++){
            data[e.target.elements[index].name] = e.target.elements[index].value;
        }

        const theFunction = (update ? Server.editStreamTarget : Server.newStreamTarget);
        if (update){
            data.streamTargetId = record.id;
            data.outputId = record.outputId;
        }
            
        theFunction(videoServer, transcoderId, data)
        .then((response)=>{
            try {
                const streamTargetId = (update ? record.idRecord : response.data.output_stream_target.id);
                const d = new Date();

                data.outputId = data.outputId || 'none';

                firebase.subCollection.add("events", id, "stream_targets", streamTargetId, { ...data, ...response.data, timestamp: d.getTime()})
                .then(()=>{
                    swal("", "Tus datos han sido guardados", "success")
                    .then(() => {
                        setLoadingStatus(false); 
                        setCurrentView("list");
                    });
                })
                    .catch((error)=>{
                    console.error(error);
                    swal("Error", "En este momento no es posible validar tu solicitud, por favor intentalo de nuevo en unos momentos", "error")
                        .then(() => {
                            setLoadingStatus(false);
                        });
                });
            } catch (error) {
                console.error(error);
                swal("Error", "En este momento no es posible validar tu solicitud, por favor intentalo de nuevo en unos momentos", "error")
                    .then(() => {
                        setLoadingStatus(false);
                    });
            }
        })
        .catch(()=>{
            swal("Error", "En este momento no es posible validar tu solicitud, por favor intentalo de nuevo en unos momentos", "error")
            .then(()=>{
                setLoadingStatus(false);
            });
        })
    }
    return (
        <ModulePanel title={[(update ? 'Editar ' : 'Nuevo') + "Stream Target"]}>
            <button style={{ position: "absolute", marginLeft: "-2.2em" }} className="btn btn-az-primary" onClick={()=>{setCurrentView("list")}}><i className="fas fa-arrow-left"/> Volver</button>
            <form ref={theForm} style={{ marginTop: "4em" }} onSubmit={onSubmit}>
                <input name="type" value={custom_type} type="hidden" />
                <FormControl title={"Nombre"}>
                    <input className="form-control" name="name" placeholder="Nombre" value={resName} onChange={(e)=>{changeName(e.target.value)}} required/>
                    <small>El nombre del punto de retransmisión. Usa un nombre para ayudar a diferenciarlo de otros destinos de transmisión</small>
                </FormControl>

                <FormControl title={"Proveedor"} isVisible={custom_type === ''}>
                    <select className="form-control" name="provider" placeholder="Proveedor" >
                        <option value="rtmp">rtmp</option>
                        <option value="rtmps">rtmps</option>
                    </select>
                    <small>Usando el listado, elije el proveedor de CDN externo al que se dirige. Elije RTMP o RTMPS si tu objetivo no es uno de los proveedores enumerados</small>
                </FormControl>

                <FormControl title={"Url del Servidor"}>
                    <input className="form-control" name="server" placeholder="Url del Servidor" required/>
                    <small>La URL de ingesta RTMP del destino, sin la barra inclinada final (/). Por ejemplo, [dominio-o-dirección-IP] / [EntryPoint]. Los nombres de host no pueden contener guiones bajos (_)</small>
                </FormControl>

                <FormControl title={"Stream Name"}>
                    <input className="form-control" name="streamName" placeholder="Stream Name" required/>
                    <small>El nombre de la transmisión <i>(Stream Name)</i> como se define en la configuración de tu objetivo</small>
                </FormControl>

                <FormControl title={"Username"} isVisible={custom_type === ''}>
                    <input className="form-control" name="username" placeholder="Username" />
                    <small>El nombre o ID que usa tu objetivo para la autenticación RTMP</small>
                </FormControl>

                <FormControl title={"Password"} isVisible={custom_type === ''}>
                    <input className="form-control" name="password" placeholder="Password" />
                    <small>La contraseña que se usa con su nombre de usuario de destino para la autenticación RTMP</small>
                </FormControl>

                <button className="btn btn-az-primary" disabled={isLoading}>
                    <i className={"fas fa-" + (isLoading ? "spinner fa-spin" : "save")}/> Guardar
                </button>
            </form>
        </ModulePanel>
    )
};

export default NewStreamTarget;

const FormControl = ({ title = "", children = null, isVisible = true }) => {
    return (
        <div className={(isVisible ? "row row-xs align-items-center mg-b-20" : 'hide')}>
            <div className="col-md-4">
                <label className="form-label mg-b-0">{title}</label>
            </div>
            <div className="col-md-8 mg-t-5 mg-md-t-0">
                {children}
            </div>
        </div>
    )
}